export default __webpack_public_path__ + "static/media/arrow-left-yellow.1af7721a.svg";